module.exports = __webpack_public_path__ + "static/media/5.fe1abb4d.jpeg";